import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';

export interface PaymentSummary {
  method: string;
  count: number;
  total: number;
}

export interface DailyClosing {
  id: number;
  branch_id: number;
  user_id: number;
  date: string;
  sales_count: number;
  total_sales: number;
  total_cash: number;
  total_transfer: number;
  total_qris: number;
  total_edc: number;
  system_cash: number;
  actual_cash: number;
  cash_difference: number;
  notes?: string;
  created_at: string;
  payment_summary: PaymentSummary[];
}

export interface DailyClosingCreate {
  actual_cash: number;
  notes?: string;
}

const API_URL = `${API_BASE_URL}/closings`;

export const getDailyClosings = async (params?: {
  branch_id?: number;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}): Promise<DailyClosing[]> => {
  const response = await api.get<DailyClosing[]>(API_URL, { params });
  return response.data;
};

export const getDailyClosingById = async (id: number): Promise<DailyClosing> => {
  const response = await api.get<DailyClosing>(`${API_URL}/${id}`);
  return response.data;
};

export const getTodaysSummary = async (): Promise<{
  sales_count: number;
  total_sales: number;
  payment_summary: PaymentSummary[];
}> => {
  const response = await api.get(`${API_URL}/today`);
  return response.data;
};

export const createDailyClosing = async (
  data: DailyClosingCreate
): Promise<DailyClosing> => {
  const response = await api.post<DailyClosing>(API_URL, data);
  return response.data;
};

// Aliases for backward compatibility
export const getDailyClosing = getTodaysSummary;
export const createClosing = createDailyClosing;
